const dev = 'http://devanalysis.g2l-service.com'; // 开发服
const test = "http://testanalysis.g2l-service.com"
const gqcDemoApi = "http://dtcapi.gqccep.com"; // 共青城演示环境
// const gqcUatApi = "http://uatdtcapi.g2l-service.com"; // 共青城UAT中非环境
const gqcUatApi = "http://uatanalysis.gqccep.com/"; // 共青城UAT中非环境
const gqcProApi = "https://dtcdataapi.gqccep.com"; // 共青城正式环境 https://bigdata.gqccep.com
const gqcMainUatApi = "http://uatdtcapi.gqccep.com"; // 共青UAT环境 只需要打包给运维更新的 - http://uatbigdata.gqccep.com
const bigDataDev = 'http://106.52.76.171'
const yqProApi = "http://dtcdataapi.yqcep.com"; // 乐清正式环境 //前端访问地址 http://bigdata.yqcep.com
const gApi = "http://192.168.1.12:8080"; // 光 http://vcev3j.natappfree.cc
const hgmApi = "http://106.52.76.171:8071/"


module.exports = {
  /**
   * 语言选择处理
   */
  // lanType: "all", // 只需要示所有可选择语言
  // lanType: 'en', // 只需要示英文
  lanType: 'zh-CN', // 只需要示中文

  /**
   * 系统类型,主要用于生成不同的皮肤系统
   */
  // sysType: "bocus", // bocus(纽中行)/gls 共青的DEV和UAT用这个皮肤
  sysType: "gqc", // 共青城演示环境
  // sysType: "yq", // 乐清
  /**
   * 设置货币符号
   */
  sysTypeUnit: "china", // ¥

  /**
   * DTC API
   */
   // apiUrl: dev // 开发服 http://devbigdata.g2l-service.com
  // apiUrl: test // 测试服 http://testbigdata.g2l-service.com
  // apiUrl: bigDataDev // bigDataDev
  // apiUrl: gqcDemoApi // 共青城演示环境
  // apiUrl: gqcUatApi // 共青城UAT中非环境
  apiUrl: gqcProApi // 共青城正式环境 https://bigdata.gqccep.com/   https://bigdataopr.gqccep.com
  // apiUrl: gApi // 光
  //  apiUrl: hgmApi //黄高明
  // apiUrl: gqcMainUatApi // 共青UAT环境 只需要打包给运维更新的 - http://uatbigdata.gqccep.com
  // apiUrl: yqProApi // 乐清正式环境 // http://bigdataopr.yqcep.com
};



//////////////////
// WEBPACK FOOTER
// ./config/host.js
// module id = PQ22
// module chunks = 1